import {CreatableSelect as AtlasKitCreatableSelect} from '@atlaskit/select';

const defaultProps = {
  ...AtlasKitCreatableSelect.defaultProps,
  placeholder: ''
};

AtlasKitCreatableSelect.defaultProps = defaultProps;

export default AtlasKitCreatableSelect;
